export default "__VITE_ASSET__BwXzm3Vk__"